module.exports = __webpack_public_path__ + "img/rocket.4e524df9.svg";